import { render, staticRenderFns } from "./subGameData.vue?vue&type=template&id=1f092694"
import script from "./subGameData.vue?vue&type=script&lang=js"
export * from "./subGameData.vue?vue&type=script&lang=js"
import style0 from "./subGameData.vue?vue&type=style&index=0&id=1f092694&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports